import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { MUTATION_KEYS, QUERY_KEYS } from 'constants/common';
import { CouponsService } from 'services/coupons';
import { type Coupon } from 'types/coupons';

export const useCreateCoupon = (): UseMutationResult<
  void,
  Error,
  { userId: string; body: Coupon }
> => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(LOCIZE_NS.CHAT);
  return useMutation<void, Error, { userId: string; body: Coupon }>({
    mutationKey: [MUTATION_KEYS.CREATE_COUPON],
    mutationFn: async ({ userId, body }: { userId: string; body: Coupon }) => {
      await CouponsService.createCoupon(userId, body);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_COUPONS] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_PATIENT] });
    },
    onError: () => {
      toast.error(t('Chat.UserInfo.Coupons.create.error'));
    },
  });
};
